import { School } from './school'
import { Teacher } from './teacher'
import { Student } from './student'

export * from './universityClazz'

export const MAX_GRADE_CLAZZ_SIZE = 300 // 一个年级最多300个班级

// 加入班级时，班级信息
export interface IGradeClazzJoin {
  class_limit: number // 班级上限, -1表示不限， 默认300
  grade_no: number // 对应的年级
  custom_class_name_map: {
    [key: string]: string // 自定义班级名称, 注意key为class_no，但是类型是str
  }
}

export interface Clazz {
  id: number
  name: string
  note_name: string | null
  grade_id: number
  grade_no: number
  class_no: number
  student_amount: number
  is_teaching: boolean

  school?: School | null
  school_id?: number | null

  students: Array<Student>
  teachers: Array<Teacher>

  locked: boolean // 是否禁止加入班级
  need_key: boolean // 是否需要班级口令
  extra_info: {
    fnReq?: boolean
    enter_class_key?: string
  } // 班级口令等额外信息
  created_time: string
  updated_time: string

  college?: {
    id: string
    school_id: string
    name: string
  }

  major?: {
    id: string
    school_id: string
    name: string
  }

  enrollment_year?: number

  available?: boolean
  is_class_manager?: boolean
  expire_time?: string // 大学版教学班过期时间
  typ?: number // 专业版或者教学班
}

export interface ISportsTeam {
  id: number
  name: string
  grade_id: number
  grade_no: number
  school_id: number
  class_no: number
  locked: boolean
  need_key: boolean
  student_amount: number
  is_teaching: boolean
  school: {
    id: number
    school_name: string
    province: string
    city: string
    district: string
    school_type: string
    amap_poi_id: string
    longitude: number
    latitude: number
  }
  note_name: string
  img_url: string
}

export interface IClazzSimple {
  class_id: number
  class_no: number
  class_name: string
  grade_id: number
  grade_no: number
  note_name: string
}

export interface IQueryClazz {
  name?: string | null
  grades?: number[] | null
}

export enum ClazzAvailableType {
  ExamPractice = 'exam_practice',
  BroadcastGymnastics = 'move_hw',
}

export interface IEditClazzNoteForm {
  class_id: number | null
  note_name: string | null
}

export interface IGradeClazzSelectOption {
  label: string
  value: number
  children: {
    label: string
    value: number
  }[]
}

export interface IClazzTreeGradeOption {
  id: number
  name: string
  grade_no?: number
  children: Clazz[]
}

export interface IStudentCodeOverView {
  student_count: number
  verified_count: number
  wait_verify_count: number
  unverified_count: number
  verify_rate: number
}

export interface IStudentAccountOverView {
  student_count: number
  activated_count: number
  wait_activate_count: number
  activated_rate: number
}

export interface ISchoolRollStudentAliFace {
  entity_id: string
  image_url: string
}

export interface IStudentTableItemForStudentCode {
  ali_face?: ISchoolRollStudentAliFace
  class_vo: Clazz
  gender: string
  name: string
  phone: string
  school_roll_no: string
  student_code: string
  student_vo: IStudentTableStudent
  verification_status: boolean
}

export interface IStudentTableItemForStudentAccount {
  name: string
  gender: string
  // 学校账号
  login_name: string
  phone: string
  activate_status: boolean
  school_roll_no: string
  student_vo: IStudentTableStudent
  class_vo: Clazz
}

export interface IStudentTableStudent {
  user_id: string
  user_no: number
  gender: string
  nick_name: string
  head_img_url: string
  verified: string
}

export interface IPaginationStudentTableItem {
  count: number
  items: IStudentTableItemForStudentCode[]
}

export interface IPaginationStudentTableItemForStudentAccount {
  count: number
  items: IStudentTableItemForStudentAccount[]
}
export interface IQueryForStudentList {
  class_id: number | null
  gender?: string | null
  grade_no?: number | null
  has_face?: boolean | null
  limit: number
  name?: string | null
  offset: number
  student_code?: string | null
  verification_status?: boolean | null
}

export type StudentTableActionType =
  | 'delStudentCode'
  | 'unBundlingStudentCode'
  | 'changeClass'
  | 'delAllStudentList'
  | 'exportFile'
  | 'delClass'
  | 'quitClass'
  | 'settingAuth'
  | string

export interface IClazzListTableAction {
  action: StudentTableActionType
  row: Clazz
}

export interface IStudentTableAction {
  action: StudentTableActionType
  row: IStudentTableItemForStudentCode
}
export interface IStudentAccountTableAction {
  action:
    | 'resetPassword'
    | 'changeClass'
    | 'downLoadStudentAccount'
    | 'unBundlingStudentPhone'
    | 'delStudentAccount'
    | 'downLoadStudentAccountIncludePassword'
    | 'delClass'
    | 'quitClass'
    | 'settingAuth'

  row: IStudentTableItemForStudentAccount
}
export interface IAddStudentCodeForm {
  name: string
  class_id: number | null
  gender: '男' | '女'
  school_roll_no: string
}

export interface IAddStudentAccountForm {
  name: string
  class_id: number | null
  gender: '男' | '女'
  school_roll_no: string
  login_name: string
  password: string
}

export interface ClazzListForSchoolRollNoItem {
  class_vo: Clazz
  student_count: number
  verified_count: number
  verify_rate: number
}

export interface IClazzListForStudentAccountTableItem {
  student_count: number
  activated_count: number
  activated_rate: number
  class_vo: Clazz
}

export interface IClazzListForStudentAccountTable {
  count: number
  items: IClazzListForStudentAccountTableItem
}
